import { useProfessionalTodos } from '@mp';
import useCurrentUser from './useCurrentUser';
import { consumeOverrideRedirect } from '../utils/persistOverrideRedirect';
import { useRef, useEffect } from 'react';
import { hasOnboardedPosition } from '../utils/onboardingHelpers';

const useOnboarding = (): {
  assignmentsMissingConditions: number[];
  hasAnOnboardedPosition: boolean;
  isAssignmentOnboardingRequired: boolean;
  showOnboarding: boolean;
} => {
  const { currentUser } = useCurrentUser();
  const { todos } = useProfessionalTodos({ enabled: !!currentUser });

  const overrideRef = useRef<boolean | undefined>(undefined);
  const isAvailableRoute =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/available');

  useEffect(() => {
    if (isAvailableRoute && overrideRef.current === undefined) {
      overrideRef.current = consumeOverrideRedirect();
    }
  }, [isAvailableRoute]);

  let showOnboarding = !hasOnboardedPosition(currentUser);

  if (isAvailableRoute && overrideRef.current) {
    showOnboarding = false;
  }

  const hasAnOnboardedPosition = hasOnboardedPosition(currentUser);

  const assignmentsMissingConditions = todos?.assignments_missing_conditions ?? [];

  return {
    assignmentsMissingConditions,
    hasAnOnboardedPosition,
    isAssignmentOnboardingRequired: !!assignmentsMissingConditions.length,
    showOnboarding,
  };
};

export default useOnboarding;
